export default "__VITE_ASSET__CV7Oh9eL__"